/**
 * World Cup 2026 multi-language translation utilities
 */

const COUNTRY_NAMES = {
  tr: {
    'Czech Republic': 'Cekya', 'Mexico': 'Meksika', 'South Africa': 'Guney Afrika',
    'South Korea': 'Guney Kore', 'Switzerland': 'Isvicre', 'Bosnia & Herzegovina': 'Bosna Hersek',
    'Canada': 'Kanada', 'Qatar': 'Katar', 'Scotland': 'Iskocya', 'Brazil': 'Brezilya',
    'Morocco': 'Fas', 'USA': 'ABD', 'Australia': 'Avustralya', 'Germany': 'Almanya', 'Ecuador': 'Ekvador',
    'Ivory Coast': 'Fildisi Sahili', 'Curacao': 'Kurasao', 'Sweden': 'Isvec',
    'Netherlands': 'Hollanda', 'Tunisia': 'Tunus', 'Japan': 'Japonya', 'Belgium': 'Belcika',
    'Egypt': 'Misir', 'Iran': 'Iran', 'New Zealand': 'Yeni Zelanda', 'Spain': 'Ispanya',
    'Cape Verde Islands': 'Yesil Burun Adalari', 'Saudi Arabia': 'Suudi Arabistan',
    'France': 'Fransa', 'Norway': 'Norvec', 'Iraq': 'Irak', 'Austria': 'Avusturya',
    'Argentina': 'Arjantin', 'Algeria': 'Cezayir', 'Jordan': 'Urdun',
    'Portugal': 'Portekiz', 'Colombia': 'Kolombiya', 'Congo DR': 'Kongo DR', 'Uzbekistan': 'Ozbekistan',
    'Croatia': 'Hirvatistan', 'England': 'Ingiltere', 'Ghana': 'Gana',
  },
  es: {
    'Germany': 'Alemania', 'Brazil': 'Brasil', 'South Korea': 'Corea del Sur', 'Scotland': 'Escocia',
    'USA': 'EE.UU.', 'France': 'Francia', 'Netherlands': 'Paises Bajos', 'England': 'Inglaterra',
    'Japan': 'Japon', 'Mexico': 'Mexico', 'Switzerland': 'Suiza', 'Turkey': 'Turquia', 'Türkiye': 'Turquia',
    'South Africa': 'Sudafrica', 'Morocco': 'Marruecos', 'Egypt': 'Egipto', 'Ivory Coast': 'Costa de Marfil',
    'New Zealand': 'Nueva Zelanda', 'Saudi Arabia': 'Arabia Saudita',
  },
  de: {
    'Brazil': 'Brasilien', 'France': 'Frankreich', 'England': 'England', 'Spain': 'Spanien',
    'Netherlands': 'Niederlande', 'Croatia': 'Kroatien', 'Belgium': 'Belgien', 'Turkey': 'Turkei', 'Türkiye': 'Turkei',
    'Switzerland': 'Schweiz', 'Austria': 'Osterreich', 'Sweden': 'Schweden', 'Norway': 'Norwegen',
    'Scotland': 'Schottland', 'South Korea': 'Sudkorea', 'Japan': 'Japan', 'Mexico': 'Mexiko',
    'USA': 'USA', 'Canada': 'Kanada', 'South Africa': 'Sudafrika', 'Morocco': 'Marokko', 'Egypt': 'Agypten',
    'Ivory Coast': 'Elfenbeinkuste', 'New Zealand': 'Neuseeland', 'Saudi Arabia': 'Saudi-Arabien',
  },
  fr: {
    'Germany': 'Allemagne', 'Brazil': 'Bresil', 'England': 'Angleterre', 'Spain': 'Espagne',
    'Netherlands': 'Pays-Bas', 'Croatia': 'Croatie', 'Belgium': 'Belgique', 'Turkey': 'Turquie', 'Türkiye': 'Turquie',
    'Switzerland': 'Suisse', 'Austria': 'Autriche', 'Sweden': 'Suede', 'Norway': 'Norvege',
    'Scotland': 'Ecosse', 'South Korea': 'Coree du Sud', 'Japan': 'Japon', 'Mexico': 'Mexique',
    'South Africa': 'Afrique du Sud', 'Morocco': 'Maroc', 'Egypt': 'Egypte',
    'Ivory Coast': "Cote d'Ivoire", 'New Zealand': 'Nouvelle-Zelande', 'Saudi Arabia': 'Arabie Saoudite',
  },
  pt: {
    'Germany': 'Alemanha', 'England': 'Inglaterra', 'Spain': 'Espanha', 'France': 'Franca',
    'Netherlands': 'Paises Baixos', 'Croatia': 'Croacia', 'Turkey': 'Turquia', 'Türkiye': 'Turquia',
    'Switzerland': 'Suica', 'Sweden': 'Suecia', 'South Korea': 'Coreia do Sul', 'Japan': 'Japao',
    'Mexico': 'Mexico', 'USA': 'EUA', 'South Africa': 'Africa do Sul', 'Morocco': 'Marrocos', 'Egypt': 'Egito',
    'Ivory Coast': 'Costa do Marfim', 'New Zealand': 'Nova Zelandia', 'Saudi Arabia': 'Arabia Saudita',
  },
  it: {
    'Germany': 'Germania', 'Brazil': 'Brasile', 'England': 'Inghilterra', 'Spain': 'Spagna',
    'France': 'Francia', 'Netherlands': 'Paesi Bassi', 'Croatia': 'Croazia', 'Belgium': 'Belgio',
    'Turkey': 'Turchia', 'Türkiye': 'Turchia', 'Switzerland': 'Svizzera', 'Sweden': 'Svezia',
    'Norway': 'Norvegia', 'Scotland': 'Scozia', 'South Korea': 'Corea del Sud', 'Japan': 'Giappone',
    'Mexico': 'Messico', 'South Africa': 'Sudafrica', 'Morocco': 'Marocco', 'Egypt': 'Egitto',
    'New Zealand': 'Nuova Zelanda', 'Saudi Arabia': 'Arabia Saudita',
  },
  nl: {
    'Germany': 'Duitsland', 'Brazil': 'Brazilie', 'France': 'Frankrijk', 'England': 'Engeland',
    'Spain': 'Spanje', 'Croatia': 'Kroatie', 'Belgium': 'Belgie', 'Turkey': 'Turkije', 'Türkiye': 'Turkije',
    'Switzerland': 'Zwitserland', 'Sweden': 'Zweden', 'Norway': 'Noorwegen', 'Scotland': 'Schotland',
    'South Korea': 'Zuid-Korea', 'Japan': 'Japan', 'USA': 'VS',
    'South Africa': 'Zuid-Afrika', 'Morocco': 'Marokko', 'Egypt': 'Egypte',
  },
};

export function translateGroupName(name, lang) {
  if (!name) return name;
  // Normalize "Group Stage - Group A" → "Group A"
  const match = name.match(/Group\s*([A-L])/i);
  if (match) {
    const letter = match[1].toUpperCase();
    if (lang === 'tr') return `Grup ${letter}`;
    if (lang === 'es') return `Grupo ${letter}`;
    if (lang === 'de') return `Gruppe ${letter}`;
    if (lang === 'fr') return `Groupe ${letter}`;
    if (lang === 'pt') return `Grupo ${letter}`;
    if (lang === 'it') return `Girone ${letter}`;
    if (lang === 'nl') return `Groep ${letter}`;
    if (lang === 'ru') return `Группа ${letter}`;
    if (lang === 'id') return `Grup ${letter}`;
    return `Group ${letter}`;
  }
  if (lang === 'tr') return name.replace('Ranking of third-placed teams', '3. sıra takım sıralaması');
  return name;
}

export function translateCountryName(name, lang) {
  if (!name) return name;
  const langMap = COUNTRY_NAMES[lang];
  if (langMap && langMap[name]) return langMap[name];
  return name;
}

export function translateSurface(surface, lang) {
  if (lang !== 'tr') return surface;
  const map = { 'Artificial Turf': 'Yapay Cim', 'Natural Grass': 'Dogal Cim', 'Hybrid Grass': 'Hibrit Cim' };
  return map[surface] || surface;
}

export function translateCountryCode(code, lang) {
  const map = {
    tr: { 'USA': 'ABD', 'Canada': 'Kanada', 'Mexico': 'Meksika' },
    es: { 'USA': 'EE.UU.', 'Canada': 'Canada', 'Mexico': 'Mexico' },
    de: { 'USA': 'USA', 'Canada': 'Kanada', 'Mexico': 'Mexiko' },
    fr: { 'USA': 'USA', 'Canada': 'Canada', 'Mexico': 'Mexique' },
    pt: { 'USA': 'EUA', 'Canada': 'Canada', 'Mexico': 'Mexico' },
    it: { 'USA': 'USA', 'Canada': 'Canada', 'Mexico': 'Messico' },
    nl: { 'USA': 'VS', 'Canada': 'Canada', 'Mexico': 'Mexico' },
  };
  return (map[lang] && map[lang][code]) || code;
}

export const MARKET_LABELS_TR = {
  '1x2': 'Mac Sonucu', 'double-chance': 'Cifte Sans', 'over-under-1.5': 'Alt/Ust 1.5',
  'over-under-2.5': 'Alt/Ust 2.5', 'over-under-3.5': 'Alt/Ust 3.5', 'btts': 'KG Var/Yok',
  'draw-no-bet': 'Beraberlikte Iade', 'first-half-1x2': 'Ilk Yari Sonucu',
  'winner': 'Mac Kazanani', 'total-points': 'Toplam Sayi A/U', 'handicap': 'Handikap',
};

export const SELECTION_LABELS_TR = {
  'home': 'Ev Sahibi', 'draw': 'Beraberlik', 'away': 'Deplasman',
  'home_draw': 'Ev/Beraberlik', 'home_away': 'Ev/Deplasman', 'draw_away': 'Beraberlik/Deplasman',
  'over': 'Ust', 'under': 'Alt', 'yes': 'Var', 'no': 'Yok',
};

export const BET_TERMS_TR = {
  'Stake:': 'Bahis:', 'Bankroll:': 'Sermaye:', 'Inverse:': 'Ters:', 'VALUE': 'DEGER', 'PROFIT': 'KAR',
  'Featured': 'One Cikan',
};

// Keep backward compat
export const COUNTRY_NAMES_TR = COUNTRY_NAMES.tr || {};

/**
 * Build a localized WC match URL slug: e.g. "meksika-vs-guney-afrika-1489369"
 */
export function wcMatchSlug(homeName, awayName, matchId, lang) {
  const h = translateCountryName(homeName, lang).toLowerCase().replace(/[^a-z0-9\u00e0-\u024f]+/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  const a = translateCountryName(awayName, lang).toLowerCase().replace(/[^a-z0-9\u00e0-\u024f]+/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  return `${h}-vs-${a}-${matchId}`;
}

/**
 * Extract numeric match ID from a WC match slug (last numeric segment).
 */
export function extractWCMatchId(slug) {
  if (!slug) return slug;
  const m = slug.match(/(\d+)$/);
  return m ? m[1] : slug;
}
